import * as types from './types';
import { errHandler, getHost } from '@kk-activity-factory/utils';

const HOST = getHost();

export default {
    getSubjectBlinkCard({ commit }, params) {
        return request({
            url: HOST + '/gamecard/v2/shinecard',
            data: params,
            type: 'GET',
        })
            .then(({ data }) => {
                commit(types.UPDATE_BLINK_CARD_INFO, { ...data, ...params });
                return data;
            })
            .catch(errHandler);
    },
};
